@file:OptIn(InternalResourceApi::class)

package ifaandroid.apps.pcos.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.apps.pcos.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_879_791_015)
internal val Res.font.roboto_serif_bold: FontResource by lazy {
      FontResource("font:roboto_serif_bold", setOf(
        ResourceItem(setOf(), "${MD}font/roboto_serif_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_082_377_382)
internal val Res.font.roboto_serif_extrabold: FontResource by lazy {
      FontResource("font:roboto_serif_extrabold", setOf(
        ResourceItem(setOf(), "${MD}font/roboto_serif_extrabold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(134_608_112)
internal val Res.font.roboto_serif_medium: FontResource by lazy {
      FontResource("font:roboto_serif_medium", setOf(
        ResourceItem(setOf(), "${MD}font/roboto_serif_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-764_793_140)
internal val Res.font.roboto_serif_regular: FontResource by lazy {
      FontResource("font:roboto_serif_regular", setOf(
        ResourceItem(setOf(), "${MD}font/roboto_serif_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_962_546_907)
internal val Res.font.roboto_serif_semibold: FontResource by lazy {
      FontResource("font:roboto_serif_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/roboto_serif_semibold.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("roboto_serif_bold", Res.font.roboto_serif_bold)
  map.put("roboto_serif_extrabold", Res.font.roboto_serif_extrabold)
  map.put("roboto_serif_medium", Res.font.roboto_serif_medium)
  map.put("roboto_serif_regular", Res.font.roboto_serif_regular)
  map.put("roboto_serif_semibold", Res.font.roboto_serif_semibold)
}
